import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'
class Toolbar extends React.Component {

  render() {

    const {
      classes,
      translate,
      viewSwitcher,
      toggle,
      add,
      showDelete,
      del,
      vnc,
      toggleFilters
    } = this.props

    return (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        {viewSwitcher ? <div style={{ display: 'flex', alignItems: 'center' }}>{viewSwitcher}</div> : null}
          <Tooltip title={translate("tooltip_add")} disableTriggerFocus={true}>
            <Button aria-label="Add Device" className={classes.button} color="primary" fab mini onClick={() => add()}>
              <Icon>add</Icon>
            </Button>
          </Tooltip>
        {showDelete && (
        <Tooltip title={translate("tooltip_delete")} disableTriggerFocus={true}>
          <Button aria-label="Delete" className={classes.button} color="primary" fab mini onClick={() => del()}>
            <Icon>delete</Icon>
          </Button>
        </Tooltip>
        )}
{/*
        <Tooltip title={translate("tooltip_team_viewer")}  disableTriggerFocus={true}>
          <Button aria-label="Team Viewer" className={classes.button} color="primary" fab mini onClick={() => vnc()}>
            <Icon>airplay</Icon>
          </Button>
        </Tooltip> */}

        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button aria-label="Filter" className={classes.button} color="primary" fab mini onClick={() => toggleFilters()}>
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>

        <Tooltip title={translate("tooltip_view_columns")} disableTriggerFocus={true}>
          <Button aria-label="View Columns" className={classes.button} color="primary" fab mini onClick={() => toggle()}>
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
